"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs = __importStar(require("query-string"));
var pathToRegexp = __importStar(require("path-to-regexp"));
var makeGetRoutePath_1 = __importDefault(require("./makeGetRoutePath"));
function makeGetPath(path) {
    var withParams = path.some(function (_a) {
        var isParam = _a.isParam;
        return isParam;
    });
    var routePath = makeGetRoutePath_1.default(path)();
    if (withParams) {
        return function (params, queryParams) {
            var queryString = queryParams ? "?" + qs.stringify(queryParams) : '';
            return "" + pathToRegexp.compile(routePath)(params) + queryString;
        };
    }
    return function (queryParams) {
        var queryString = queryParams ? "?" + qs.stringify(queryParams) : '';
        return "" + routePath + queryString;
    };
}
exports.default = makeGetPath;
